module.exports = __webpack_public_path__ + "img/chevron-expand.dd1e03b9.svg";